<script setup lang="ts">
import { computed, inject } from "vue";

import * as tmi from "@/constants";

import { useProductFilter } from "@/composables/filters/product-filter";
import { useProductsStore } from "@/stores/Products";
import type { PagingFilter } from "@/composables/filters/paging-filter";
import { pagingFilterSymbol } from "@/plugins/ContentFiltersPlugin";
import { storeToRefs } from "pinia";

const { hasProductsToFilter, includeProductFilter } = useProductFilter();
const productsStore = useProductsStore();
const { subscribedProducts } = storeToRefs( productsStore );
const selectionOptionsForProductsFilter = computed< any[] >( () => [ ...subscribedProducts.value, productsStore.productBySlug( tmi.TmiPublicContentPermissionKey ) ] );

const pagingFilter = inject< PagingFilter >( pagingFilterSymbol ) as PagingFilter;
function resetPageNumber() {
  pagingFilter?.resetPageNumber();
}
</script>

<template>
  <MultiSelect
      v-if="hasProductsToFilter"
      v-model="includeProductFilter"
      :options="selectionOptionsForProductsFilter"
      optionLabel="name"
      @change="resetPageNumber"
      dataKey="id"
      placeholder="Filter by Products"
      class="w-full"/>
</template>
